import Vue from 'vue'
import App from './App.vue'
import store from "./store";
import axios from 'axios';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.config.productionTip = false
Vue.use(VueSweetalert2);

// Axios 请求拦截器：自动携带大屏登录 token
axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('app-token');
    if (token) {
        config.headers['XX-Token'] = token;
        config.headers['XX-Device-Type'] = 'web';
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Axios 响应拦截器：统一处理 401 未授权
axios.interceptors.response.use(function (response) {
    if (response.data && (response.data.code === 401 || response.data.code === '401')) {
        localStorage.removeItem('app-token');
        localStorage.removeItem('app-user-info');
        store.dispatch("changeDispatch", '');
        store.dispatch("doChangeUserInfo", {});
        window.location.reload();
    }
    return response;
}, function (error) {
    if (error.response && error.response.status === 401) {
        localStorage.removeItem('app-token');
        localStorage.removeItem('app-user-info');
        store.dispatch("changeDispatch", '');
        store.dispatch("doChangeUserInfo", {});
        window.location.reload();
    }
    return Promise.reject(error);
});

new Vue({
    store,
    render: h => h(App),
}).$mount('#app')
